import { Injector, ElementRef } from '@angular/core';
import { TemplatingService } from './templating.service';
import { TranslateService } from '@ngx-translate/core';

export class TemplatingClass {
  /** Page template and vars service */
  protected templateService: TemplatingService;
  protected translateService: TranslateService;
  /** Custom template for every component */
  protected componentTemplate: any;
  protected nativeElement: HTMLElement;
  /** Activated language */
  public lang: string;

  constructor(injector: Injector) {
    this.templateService = injector.get(TemplatingService);
    this.translateService = injector.get(TranslateService);
  }
  /**
   *
   * @param element
   * @param template
   * @param componentTemplate
   */
  protected initialize(element: ElementRef, defaultTemplate, customTemplate = null) {
    if (!customTemplate) {
      customTemplate = { colors: {} };
    }
    const colors = { ...defaultTemplate.colors };
    this.componentTemplate = {
      ...defaultTemplate,
      ...customTemplate,
      colors: { ...colors, ...customTemplate.colors }
    }
    this.nativeElement = element.nativeElement;
    this.templateService.setComponentTemplate(this.componentTemplate.colors, this.nativeElement);
    this.lang = this.translateService.currentLang;
  }
  /** Get native stored element */
  public getNativeElement(): HTMLElement {
    return this.nativeElement;
  }
}
